import { Controller } from "@hotwired/stimulus"

// Nested line item rows for quotes and invoices: add/remove rows and live totals.
export default class extends Controller {
  static targets = ["rows", "template", "row", "currency", "net", "iva", "total", "catalog"]

  connect() {
    this.recalculate()
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.recalculate()
  }

  // Adds a row pre-filled from the selected catalog item.
  addFromCatalog() {
    const option = this.catalogTarget.selectedOptions[0]
    if (!option || !option.value) return

    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString())
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    const row = this.rowTargets[this.rowTargets.length - 1]
    row.querySelector("input[name*='[description]']").value = option.dataset.description
    row.querySelector("[data-field='quantity']").value = 1
    row.querySelector("[data-field='unit_price']").value = option.dataset.price
    this.catalogTarget.value = ""
    this.recalculate()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-line-items-target='row']")
    const destroyField = row.querySelector("input[name*='_destroy']")
    if (row.dataset.newRecord === "true") {
      row.remove()
    } else {
      destroyField.value = "1"
      row.hidden = true
      row.style.display = "none" // the row's grid class would otherwise override [hidden]
    }
    this.recalculate()
  }

  recalculate() {
    const uf = this.hasCurrencyTarget && this.currencyTarget.value === "uf"
    const round = (value) => uf ? Math.round(value * 100) / 100 : Math.round(value)
    let net = 0

    this.rowTargets.filter((row) => !row.hidden).forEach((row) => {
      const quantity = parseFloat(row.querySelector("[data-field='quantity']").value) || 0
      const price = parseFloat(row.querySelector("[data-field='unit_price']").value) || 0
      const lineTotal = round(quantity * price)
      row.querySelector("[data-field='total']").textContent = this.format(lineTotal, uf)
      net += lineTotal
    })

    // Catalog items only match documents in the same currency.
    if (this.hasCatalogTarget && this.hasCurrencyTarget) {
      Array.from(this.catalogTarget.options).forEach((option) => {
        if (option.value) option.disabled = option.dataset.currency !== this.currencyTarget.value
      })
    }

    const iva = round(net * 0.19)
    this.netTarget.textContent = this.format(net, uf)
    this.ivaTarget.textContent = this.format(iva, uf)
    this.totalTarget.textContent = this.format(net + iva, uf)
  }

  format(value, uf) {
    const number = value.toLocaleString("es-CL", { minimumFractionDigits: uf ? 2 : 0, maximumFractionDigits: uf ? 2 : 0 })
    return uf ? `UF ${number}` : `$${number}`
  }
}
